"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _token = require("./../utils/token");

var indeterminateLinearAnimation = (0, _emotion.keyframes)({
  from: {
    transform: "scaleX(0.25) translateX(-100%)"
  },
  to: {
    transform: "scaleX(1) translateX(150%)"
  }
});
var linearWrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _emotion.css)({
    display: "flex",
    borderRadius: t("borderRadius"),
    width: "100%",
    minWidth: 100,
    height: t("trackLinear", [size, "height"]),
    backgroundColor: t("trackBackgroundColor"),
    position: "relative",
    overflow: "hidden"
  });
}, ["size"]);
var linearIndicatorStyle = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var determinate = _ref2.determinate,
      _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage;
  return (0, _emotion.css)({
    width: "".concat(percentage, "%"),
    height: "100%",
    backgroundColor: t("indicatorBackgroundColor"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  }, !determinate ? linearIndeterminateStyle(t) : undefined);
}, ["determinate", "percentage"]);

var linearIndeterminateStyle = function linearIndeterminateStyle(t) {
  return {
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: t("borderRadius"),
    transformOrigin: "top left",
    animation: "".concat(indeterminateLinearAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  };
};

var linearPercentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var percentage = _ref3.percentage;
  return (0, _emotion.css)({
    width: "".concat(percentage, "%"),
    textAlign: "right",
    marginTop: t("percentageSpacing"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  });
}, ["percentage"]);
/* eslint-disable react/prop-types */

var LinearLoader = function LinearLoader(_ref4) {
  var t = _ref4.t,
      percentage = _ref4.percentage,
      showPercentageText = _ref4.showPercentageText,
      size = _ref4.size,
      determinate = _ref4.determinate;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearWrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearIndicatorStyle(t, {
      determinate: determinate,
      percentage: percentage
    })
  })), determinate && showPercentageText ? /*#__PURE__*/_react["default"].createElement("div", {
    className: linearPercentageStyle(t, {
      percentage: percentage
    })
  }, "".concat(percentage, "%")) : null);
};
/* eslint-enable react/prop-types */


var _default = LinearLoader;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@meridian/components/loader/linear.js
// module id = 185
// module chunks = 7